import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CustomerSampleAllocation } from "@omni/classes/sample/customer-sample-allocation.class";

@Component({
  selector: 'allocation-eligibility',
  templateUrl: 'allocation-eligibility.html',
  styleUrls: ['allocation-eligibility.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllocationEligibilityComponent {
  @Input() sampleEligibilities: Array<CustomerSampleAllocation>;

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }

  constructor(
    public translate: TranslateService,
    private readonly cd: ChangeDetectorRef,
  ) { }
}